import React, { useContext } from "react";
import moment from "moment";
import styles from "./Chat.module.scss";
import classNames from "classnames";
import ChatContext from "../../context/ChatContext";

export default function ConversationPreview({ channel, onLeaveChannel }) {
  const { lastMessage, members } = channel;
  const { chatInfo } = useContext(ChatContext);

  const otherChatter = members.find(
    (member) => member.userId != chatInfo.userId
  );
  return (
    <div
      role="link"
      className={classNames("sendbird-channel-preview", styles.channelPreview)}
    >
   <div className="sendbird-channel-preview__avatar">
        <div className="sendbird-chat-header__avatar">
          <img
            className="sendbird-avatar"
            style={{ height: "52px", width: "52px", objectFit: "cover" }}
            src={otherChatter && otherChatter.profileUrl}
          />
        </div>
      </div>
      <div className="sendbird-channel-preview__content">
        <div className="sendbird-channel-preview__content__upper">
          <div className="sendbird-channel-preview__content__upper__header">
            <div className="sendbird-label sendbird-channel-preview__content__upper__header__channel-name sendbird-label--subtitle-2 sendbird-label--color-onbackground-1">
              {otherChatter && otherChatter.nickname}
            </div>
            {otherChatter && otherChatter.connectionStatus == "online" && (
              <div
                style={{
                  background: "#37ffad",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%"
                }}
                className="sendbird-label sendbird-channel-preview__content__upper__header__total-members sendbird-label--caption-2 sendbird-label--color-onbackground-2"
              ></div>
            )}
          </div>
          <div className="sendbird-label sendbird-channel-preview__content__upper__last-message-at sendbird-label--caption-3 sendbird-label--color-onbackground-2">
            {lastMessage && lastMessage.createdAt
              ? moment(lastMessage.createdAt).format("DD/MM/YYYY")
              : ""}
          </div>
        </div>
        <div className="sendbird-channel-preview__content__lower">
          <div className="sendbird-label sendbird-channel-preview__content__lower__last-message sendbird-label--body-2 sendbird-label--color-onbackground-3">
            {lastMessage && lastMessage.message}
          </div>
          <div className="sendbird-channel-preview__content__lower__unread-message-count">
            {!!channel.unreadMessageCount && channel.unreadMessageCount}
          </div>
        </div>
      </div>
    </div>
  );
}
